import styled from "styled-components";
export const ButtonSetServices = styled.div`
  gap: 3vw;
  display: flex;
  /* margin-top: 30px; */
  text-align: center;
  justify-content: center;
  div:nth-child(3) {
    display: none;
  }
  div {
    margin-left: 0 !important;
    button {
      @media (max-width: 767px) {
        top: 0 !important;
      }
    }
  }
  .alert-modal {
    display: none;
  }
  button {
    background-color: #233354;
    color: rgb(255, 255, 255);
    border: none;
    padding: 12px;
    font-size: 16px;
    width: 260px !important;
    margin-top: min(1.75vw, 25px);
    @media (max-width: 1023px) {
      width: 260px !important;
      font-size: 10px !important;
    }
    @media (max-width: 767px){
      font-size: 14px !important;
    }
  }
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;
